export default __webpack_public_path__ + "static/media/shareIcon.21db1e75.svg";